// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1WTnA","head":"Table_head__3KkBZ","col":"Table_col__2cabI"};